import { ProductModel } from './product-model';
import { Type } from '@angular/core';
import { HorizontalProductModelComponent } from './horizontal-product-model/horizontal-product-model.component';
import { HighPerformanceProductModelComponent } from './high-performance-product-model/high-performance-product-model.component';
import { BeltDriveProductModelComponent } from './belt-drive-product-model/belt-drive-product-model.component';
import { BeltDriveRateProductModelComponent } from './belt-drive-rate-product-model/belt-drive-rate-product-model.component';
import { CabinetUnitHeaterProductModelComponent } from './cabinet-unit-heater-product-model/cabinet-unit-heater-product-model.component';
import { DirectDriveBlowerCoilProductModelComponent } from './direct-drive-blower-coil-product-model/direct-drive-blower-coil-product-model.component';
import { FluidCoolerProductModelComponent } from './fluid-cooler-product-model/fluid-cooler-product-model.component';
import { MiniRestoraModProductModelComponent } from './mini-restora-mod-product-model/mini-restora-mod-product-model.component';
import { ModularProductModelComponent } from './modular-product-model/modular-product-model.component';
import { ModularQuickShipProductModelComponent } from './modular-quick-ship-product-model/modular-quick-ship-product-model.component';
import { RestoraModProductModelComponent } from './restora-mod-product-model/restora-mod-product-model.component';
import { VerticalFloorProductModelComponent } from './vertical-floor-product-model/vertical-floor-product-model.component';
import { VerticalFloorClassicProductModelComponent } from './vertical-floor-classic-product-model/vertical-floor-classic-product-model.component';
import { VerticalLowboyProductModelComponent } from './vertical-lowboy-product-model/vertical-lowboy-product-model.component';
import { VerticalStudProductModelComponent } from './vertical-stud-product-model/vertical-stud-product-model.component';
import { UnknownProductModelComponent } from './unknown-product-model/unknown-product-model.component';
import { HorizontalCabinetUnitHeaterModelComponent } from './horizontal-cabinet-unit-heater-model/horizontal-cabinet-unit-heater-model.component';
import { MegaModProductModelComponent } from './mega-mod-product-model/mega-mod-product-model.component';
import { FanPoweredTerminalUnitProductModelComponent } from './fan-powered-terminal-unit-product-model/fan-powered-terminal-unit-product-model.component';
import { VerticalFloorAProductModelComponent } from './vertical-floor-a-product-model/vertical-floor-a-product-model.component';
import { VerticalFloorASureflowProductModelComponent } from './vertical-floor-a-sureflow-product-model/vertical-floor-a-sureflow-product-model.component';
import { HorizontalSureflowProductModelComponent } from './horizontal-sureflow-product-model/horizontal-sureflow-product-model.component';
import { HighPerformanceSureflowProductModelComponent } from './high-performance-sureflow-product-model/high-performance-sureflow-product-model.component';
import { ModularSureflowProductModelComponent } from './modular-sureflow-product-model/modular-sureflow-product-model.component';
import { MegaModSureflowProductModelComponent } from './mega-mod-sureflow-product-model/mega-mod-sureflow-product-model.component';
import { EnviroKitProductModelComponent } from './enviro-kit-product-model/enviro-kit-product-model.component';
import { AirHandlerUnitProductModelComponent } from './air-handler-unit-product-model/air-handler-unit-product-model.component';

export class ProductModelFactory {
  static buildComponent(productId: string): Type<ProductModel> {
    switch (productId) {
      case 'Horizontal':
        return HorizontalProductModelComponent;
      case 'Horizontal-Sureflow':
        return HorizontalSureflowProductModelComponent;
      case 'HighPerformance':
        return HighPerformanceProductModelComponent;
      case 'HighPerformance-Sureflow':
        return HighPerformanceSureflowProductModelComponent;
      case 'BeltDrive':
        return BeltDriveProductModelComponent;
      case 'BeltDriveRate':
        return BeltDriveRateProductModelComponent;
      case 'CabinetUnitHeater':
        return CabinetUnitHeaterProductModelComponent;
      case 'DirectDriveBlowerCoil':
        return DirectDriveBlowerCoilProductModelComponent;
      case 'FluidCooler':
        return FluidCoolerProductModelComponent;
      case 'MiniRestoraMod':
        return MiniRestoraModProductModelComponent;
      case 'Modular-Sureflow':
        return ModularSureflowProductModelComponent;
      case 'Modular':
        return ModularProductModelComponent;
      case 'ModularQuickShip':
        return ModularQuickShipProductModelComponent;
      case 'RestoraMod':
        return RestoraModProductModelComponent;
      case 'VerticalFloor':
        return VerticalFloorProductModelComponent;
      case 'VerticalFloorClassic':
        return VerticalFloorClassicProductModelComponent;
      case 'VerticalLowboy':
        return VerticalLowboyProductModelComponent;
      case 'VerticalStud':
        return VerticalStudProductModelComponent;
      case 'HorizontalCabinetUnitHeater':
        return HorizontalCabinetUnitHeaterModelComponent;
      case 'MegaMod-Sureflow':
        return MegaModSureflowProductModelComponent;
      case 'MegaMod':
        return MegaModProductModelComponent;
      case 'FanPoweredTerminalUnit':
        return FanPoweredTerminalUnitProductModelComponent;
      case 'VerticalFloorA':
        return VerticalFloorAProductModelComponent;
      case 'VerticalFloorA-Sureflow':
        return VerticalFloorASureflowProductModelComponent;
      case 'EnviroKit':
        return EnviroKitProductModelComponent;
      case 'AirHandlerUnit':
        return AirHandlerUnitProductModelComponent;
      default:
        return UnknownProductModelComponent;
    }
  }
}
